import React from "react";
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDInput from "../../../../../components/MDInput";

function FormField({ label, ...rest }) {
  return <MDInput {...rest} label={label} variant="standard" fullWidth />;
}

// typechecking props for FormField
FormField.propTypes = {
  label: PropTypes.string.isRequired,
};

export default FormField;
